import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {AdService} from '@services/ad.service';
import {Tab} from '@models/tab';
import {Favorite} from '@models/favorite';
import {WidgetDirective} from '@components/widget/widget.directive';
import {EMPTY_FAVORITE, EMPTY_USER} from '@models/empty';
import * as $ from 'jquery';
import {User} from '@models/user';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {AlertService} from '@services/alert.service';

@Component({
    selector: 'app-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {

    @ViewChildren(WidgetDirective) widgets: QueryList<WidgetDirective>;

    tab: Tab;
    tabs: Tab[] = [];
    edit = false;
    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    params;
    user: User = Object.assign({}, EMPTY_USER);

    constructor(
        public dialog: MatDialog,
        private route: ActivatedRoute,
        private adService: AdService,
        private alertService: AlertService,
        private router: Router,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService) {
    }

    ngOnInit() {
        this.route.data.subscribe(data => {
            this.tab = Object.assign({}, data.tab);
            this.edit = data.edit;

            this.user = this.authenticationService.currentUser;
            if (this.edit === true) {
                if (this.authenticationService.isAllowed('expert')) {
                    $(document).ready(() => {
                        $('app-sidebar').removeClass('collapsed');
                        $('#content').removeClass('extended');
                    });
                } else {
                    this.router.navigate(['/app/favorites']);
                }
            }
        });

        this.route.parent.params.subscribe(params => {
            this.params = params;

            this.adService.getCacheFavorite().subscribe({
                next: (result) => {
                    this.favorite = this.adService.updateValues(result);
                },
                error: (error) => {
                    if (error != "token_outdate") {
                        this.alertService.error('Favoris introuvable', true);
                        this.router.navigate(['/app/favorites', params.id]);
                    }
                },
                complete: () => console.info('complete')
            })
        });
    }

    updateAd() {
        this.adService.updateFavorite(this.favorite);
    }
}
